<template>
  <el-table class="list" id="listOrgs" :data="orgs">
    <el-table-column prop="org_name" label="Наименование">
      <template slot-scope="scope">
        <router-link class="link" :to="'/org/edit/' + scope.row.id_org">
          {{ scope.row.org_name || "Нет данных" }}
        </router-link>
      </template>
    </el-table-column>
    <el-table-column prop="count" label="Количество камер" />
    <el-table-column align="center" width="120px" v-if="$can('delete', 'orgs')" label="Действия">
      <template slot-scope="scope">
        <el-button size="small" type="danger" @click="onRemove(scope.row.id_org)">
          Удалить <fa :icon="['fas', 'trash-alt']" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { mapActions, mapState } from "vuex";

library.add(faTrashAlt);

export default {
  name: "OrgsTable",
  components: { fa },
  computed: {
    ...mapState("orgs", {
      orgs: (state) => state.data,
    }),
  },
  methods: {
    ...mapActions("org", {
      deleteOrg: "DELETE_ORG",
    }),
    onRemove(id) {
      const org = this.orgs.find((c) => c.id_org === id);
      this.$confirm(`Вы точно хотите удалить юр. лицо "${org.org_name} ?"`, "Подтверждение", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        type: "warning",
      }).then(() => this.remove(id));
    },
    remove(id) {
      this.deleteOrg(id)
        .then(() => {
          this.$message({
            message: "Клиент удален",
            type: "success",
          });
          this.$emit("orgDeleted");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Ошибка при удалении клиента");
        });
    },
  },
};
</script>
